import React from "react";
import { Container, Grid, Card, CardContent, Typography, Button, Box, IconButton } from "@mui/material";
import { ArrowBackIos, School, AutoFixHigh, TravelExplore, Celebration } from "@mui/icons-material";
import { NavLink, Link } from "react-router-dom";
import { HeaderComponent } from "../../components/Header/index";

const categories = [
  {
    title: "Quince",
    description: "Gestión de paquetes para viajes de quinceañeras.",
    id: "quince",
    icon: <Celebration sx={{ fontSize: 40, mb: 2, color: '#e91e63' }} />
  },
  {
    title: "Egresados",
    description: "Gestión de paquetes para viajes de egresados.",
    id: "egresados",
    icon: <School sx={{ fontSize: 40, mb: 2, color: '#2196f3' }} />
  },
  {
    title: "Educativos",
    description: "Gestión de paquetes para viajes educativos.",
    id: "educativos",
    icon: <TravelExplore sx={{ fontSize: 40, mb: 2, color: '#4caf50' }} />
  },
  {
    title: "Eventos",
    description: "Gestión de paquetes para eventos.",
    id: "eventos",
    icon: <Celebration sx={{ fontSize: 40, mb: 2, color: '#9c27b0' }} />
  },
  {
    title: "Otros",
    description: "Otros tipos de paquetes grupales.",
    id: "otros",
    icon: <AutoFixHigh sx={{ fontSize: 40, mb: 2, color: '#ff9800' }} />
  }
];

export const CategorySelection: React.FC = () => {
  return (
    <Container 
      maxWidth={false} 
      sx={{ 
        minHeight: 'calc(100vh - 64px)', 
        display: 'flex', 
        flexDirection: 'column',
        px: { xs: 2, md: 4 },
        py: 2,
        overflowX: 'hidden',
        backgroundColor: '#f8f9fa'
      }}
    >
      <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
        <IconButton component={Link} to="/" sx={{ mr: 2, backgroundColor: 'white', '&:hover': { backgroundColor: '#eee' }, boxShadow: 1 }}>
          <ArrowBackIos fontSize="small" />
        </IconButton>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', letterSpacing: '-0.5px' }}>
            Paquetes Grupales
          </Typography>
        </Box>
      </Box>

      <Grid 
        container 
        spacing={3} 
        justifyContent="center"
        sx={{ 
          mt: 4,
          px: { md: 8, lg: 12 },
          alignItems: 'stretch', // Estira los items para que tengan la misma altura
          pb: 4
        }}
      >
        {categories.map((cat) => (
          <Grid item xs={12} sm={6} md={2.4} key={cat.id}>
            <Card
              sx={{
                textAlign: "center",
                display: 'flex',
                flexDirection: 'column',
                height: '100%', // Fuerza la altura completa
                transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'white',
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: '0 10px 20px rgba(0,0,0,0.08)',
                  cursor: "pointer",
                  borderColor: 'primary.main',
                },
              }}
            >
              <CardContent sx={{ 
                py: 4,
                px: 2.5,
                flexGrow: 1, // Hace que el contenido crezca uniformemente
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center' // Centra el contenido verticalmente si hay espacio extra
              }}>
                <Box sx={{ 
                  backgroundColor: 'action.hover', 
                  p: 1.5, 
                  borderRadius: 3, 
                  mb: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {React.cloneElement(cat.icon as React.ReactElement, { sx: { fontSize: 32, color: (cat.icon as any).props.sx.color } })}
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                  {cat.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, px: 2, minHeight: '3em' }}>
                  {cat.description}
                </Typography>
                <Button
                  component={NavLink}
                  to={`/paquetes-grupales/${cat.id}`}
                  variant="outlined"
                  fullWidth
                  size="medium"
                  sx={{ 
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                  }}
                >
                  Entrar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CategorySelection;
